import { useCallback } from 'react';
import ApexChart from 'react-apexcharts';

import { getChartConfig } from './SymptomChart.utils';
import { useStyles } from './SymptomChart.styles';

const SymptomChart = ({ name, items }) => {
  const classes = useStyles();

  const chartConfig = useCallback(opt => {
    return getChartConfig(opt);
  }, []);

  return (
    <div className={classes.chart}>
      <ApexChart {...chartConfig({ name, items })} type="line" height={330} />
    </div>
  );
};

export { SymptomChart };
